enum BiteLogLoyaltyEvent {
  OK = 0,
  Authed = 1,
  AuthError = 2,
  AuthSkipped = 3,
  RewardsFetched = 4,
  RewardsFetchError = 5,
  RewardsFetchSkipped = 6,
  RewardsApplied = 7,
  RewardsApplyError = 8,
  RewardsApplySkipped = 9,
  RewardRemoved = 10,
  RewardRemoveError = 11,
  RewardRemoveSkipped = 12,
  GiftCardInquiry = 13,
  GiftCardInquiryError = 14,
  GiftCardInquirySkipped = 15,
  GiftCardApplied = 16,
  GiftCardApplyError = 17,
  GiftCardApplySkipped = 18,
  GiftCardRefunded = 19,
  GiftCardRefundError = 20,
  GiftCardRefundSkipped = 21,
  CouponApplied = 22,
  CouponApplyError = 23,
  CouponApplySkipped = 24,
  CouponRemoved = 25,
  CouponRemoveError = 26,
  CouponRemoveSkipped = 27,
  RewardsApplyBestEffortFailed = 28,
  CouponSingleRedemptionRedeemed = 29,

  RewardCodeRedeemed = 30,
  RewardCodeRedeemError = 31,
  RewardCodeRedeemSkipped = 32,

  TipRedeemedOnLoyalty = 40,
  TipRedeemOnLoyaltyError = 41,
  RewardFetchedOnLoyalty = 42,
  RewardFetchedOnLoyaltyError = 43,

  CompCardApplied = 51,
  CompCardApplyError = 52,
  CompCardRemoved = 53,
  CompCardRemoveError = 54,

  LoyaltySignUpError = 60,
  LoyaltyFailedToCheckin = 61,
}

export { BiteLogLoyaltyEvent };
